import { GetSubmissionResponse, GetSubmissionWorkflow, useApiQuery } from "api";
import LoadingPage from "components/common/LoadingPage";
import PageComponent from "components/common/PageComponent";
import useSession from "hooks/useSession";
import { lazy, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { getSocietyId } from "utils/getSocietyId";
import { getProfileId } from "utils/sessionStorage/user";

interface RouteParams {
  id: string;
}

const LazyLoadedSurveyPreview = lazy(() =>
  import("admin/src/ui/components/surveyJS/preview/SurveyPreview").then(
    (module) => ({
      default: module.SurveyPreview,
    }),
  ),
);

const SubmissionPage = () => {
  const { id } = useParams<RouteParams>();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [responseData, setResponseData] = useState<any>();
  const [formId, setFormId] = useState<number>();
  const [form, setForm] = useState<any>();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const session = useSession();
  const uiMsg = queryParams.get("message");

  const assignmentId = queryParams.get("submissionAssignmentId");
  const {
    data: getSubmissionResponseData,
    isLoading: getSubmissionResponseIsLoading,
  } = useApiQuery(
    GetSubmissionResponse,
    {
      societyId: getSocietyId().toString(),
      submissionResponseId: queryParams.get("submissionResponseId"),
    },
    {},
    {},
    { enabled: !!queryParams.get("submissionResponseId") },
  );

  const { data: getSubmissionWorkflowResponse, isLoading: isFetchingResponse } =
    useApiQuery(
      GetSubmissionWorkflow,
      { societyId: getSocietyId().toString(), submissionWorkflowId: id },
      { profileId: getProfileId() },
    );
  useEffect(() => {
    const submissionResponseId = queryParams.get("submissionResponseId");
    const responseData = getSubmissionResponseData?.data?.body?.responseData;
    setFormId(
      getSubmissionWorkflowResponse?.data?.body?.submissionProcess?.responseForm
        ?.id,
    );

    if (!submissionResponseId) {
      setResponseData({});
      setLoading(false);
      return;
    }

    if (getSubmissionResponseIsLoading && !loading) {
      return;
    }

    if (!responseData) {
      return;
    }

    setResponseData(responseData);
    setLoading(false);
  }, [getSubmissionResponseData]);

  useEffect(() => {
    if (
      getSubmissionWorkflowResponse?.data?.body?.submissionProcess?.responseForm
    ) {
      setForm(
        getSubmissionWorkflowResponse?.data?.body?.submissionProcess
          ?.responseForm.formDesign,
      );
    }
    console.log("formFromSubmission", form);
  }, [getSubmissionWorkflowResponse]);

  const getExistingResponseFormDesign = () => {
    if (!getSubmissionResponseData?.data?.body?.formDesign) {
      return null; // No existing response from design
    }

    if (getSubmissionResponseData.data.body.profileId !== getProfileId()) {
      return null; // Not for logged in user
    }
    return getSubmissionResponseData?.data?.body?.formDesign;
  };

  const getExistingResponseData = () => {
    if (!getSubmissionResponseData?.data?.body?.responseData) {
      return null; // No existing User Response Data
    }

    if (
      getSubmissionResponseData.data.body.profileId !== getProfileId() ||
      getSubmissionResponseData?.data?.body?.status === "Complete"
    ) {
      return null; // Not for logged in user
    }

    return getSubmissionResponseData?.data?.body?.responseData;
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <PageComponent>
      <PageComponent.Header>Form</PageComponent.Header>
      <PageComponent.Content>
        {uiMsg && (
          <div className="flex justify-center p-2">
            <h4 className="font-medium w-max">{uiMsg}</h4>
          </div>
        )}

        {getSubmissionWorkflowResponse?.data && form && (
          <>Gary Removed this post udig</>
        )}
      </PageComponent.Content>
    </PageComponent>
  );
};

export default SubmissionPage;
